import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5e0a210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-title" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("レポート")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("追加")

import { useStore } from "vuex";
import { computed, onMounted, ref } from 'vue'
import { AlertForm } from "@/types/alert_form";
import { AlertFormsRepository } from "@/repositories/AlertFormsRepository"
import { useExceptionMessage } from '@/logic/ExceptionMessageLogic'



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const alertFormLoading = ref(false);

const repository = new AlertFormsRepository()
const store = useStore();
const managerFlg = computed(() => store.state.login.manager_flg);
const alertForms = ref<AlertForm[]>([])
onMounted(async (): Promise<void> => {
  alertFormLoading.value = true;
  try {
    alertForms.value = await repository.getReport()
    alertFormLoading.value = false;
  } catch (e: any) {
    useExceptionMessage(e, "エラーが発生しました。<br>再読み込みしてお試しください");
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        class: "container container__card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_card, { class: "box-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertForms.value, (alertForm) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: alertForm.id,
                          class: "flex"
                        }, [
                          _createElementVNode("span", _hoisted_1, _toDisplayString(alertForm.title), 1),
                          _createElementVNode("div", null, [
                            _createVNode(_component_router_link, {
                              to: { name: 'AlertFormsEdit', params: { alert_form_id: alertForm.id } },
                              class: "button-link ml10"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "info",
                                  round: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_2
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            _createVNode(_component_router_link, {
                              to: { name: 'AlertFormsReport', params: { alert_form_id: alertForm.id } },
                              class: "button-link ml10"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, { round: "" }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createVNode(_component_router_link, {
                    to: { name: 'AlertFormsCreate' },
                    class: "button-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "primary" }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_directive_loading, alertFormLoading.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})